import React from 'react';
import styles from './fullpagebackground.scss';

const FullPageBackground = ({ children }) =>
  <div className="full-page-background">{children}</div>

export default FullPageBackground;



// WEBPACK FOOTER //
// ./src/components/layout/FullPageBackground.js